import api from '@/api'
import axios from 'axios'
import qs from 'qs'
//获取订单列表
export async function getOrderList(param) {
  var paramStr='SkipCount='+ param.skipCount;
  paramStr += '&MaxResultCount='+ param.maxResultCount;
  if(param.orderType!=null&&param.orderType!=''&&param.orderType!=undefined)
  {
    paramStr += '&orderType='+param.orderType;
  }
  if(param.productName!=null&&param.productName!=''&&param.productName!=undefined)
  {
    paramStr += '&productName='+ encodeURIComponent(param.productName);
  }
  if(param.createStartTime!=null&&param.createStartTime!=''&&param.createStartTime!=undefined)
  {
    var tempDate = new Date(param.createStartTime);
     var y= tempDate.getFullYear();
     var m = (tempDate.getMonth()+1)<10?('0'+(tempDate.getMonth()+1)):(tempDate.getMonth()+1);
     var d = tempDate.getDate()<10?('0'+tempDate.getDate()):tempDate.getDate();
     paramStr += '&createStartTime='+encodeURIComponent(y+'-'+m+'-'+d);
  }
  if(param.createEndTime!=null&&param.createEndTime!=''&&param.createEndTime!=undefined)
  {
    var tempDate = new Date(param.createEndTime);
    var y= tempDate.getFullYear();
    var m = (tempDate.getMonth()+1)<10?('0'+(tempDate.getMonth()+1)):(tempDate.getMonth()+1);
    var d = tempDate.getDate()<10?('0'+tempDate.getDate()):tempDate.getDate();
     paramStr += '&createEndTime='+encodeURIComponent(y+'-'+m+'-'+d);
  }
 
  return api.get('api/services/app/FrontendOrders/GetOrderList?'+ paramStr)
}

//获取订单
export async function getOrder(data) {
  return api.get('api/services/app/FrontendOrders/GetOrderDetails?id='+data.id)
}

//获取订单
export async function getMultipleOrder(data) {
  return api.post('api/services/app/FrontendOrders/DoGetMultipleOrderDetails',data)
}

//订单退款
export async function refund(data) {
  return  api.post('api/services/app/FrontendRefund/RefundMoney',data)
}

//订单退货
export async function returnGoods(data) {
  return  api.post('api/services/app/FrontendRefund/RefundItem',data)
}

//寄回商品
export async function returnItemBack(data) {
  return  api.post('api/services/app/FrontendRefund/ReturnItemBack',data)
}

//取消退款
export async function cancelRefund(data) {
  return  api.post('api/services/app/FrontendRefund/CancelRefundMoney',data)
}

//取消退货
export async function cancelReturn(data) {
  return  api.post('api/services/app/FrontendRefund/CancelRefundItem',data)
}

//完成订单
export async function finish(data) {
  return  api.post('api/services/app/FrontendOrders/Finish',data)
}

//评价
export async function evaluate(data) {
  return  api.post('api/services/app/FrontendOrders/EvaluateOrder',data)
}

//申请发票
export async function applyInvoice(data) {
  return  api.post('api/services/app/FrontendOrderInvoice/ApplyInvoice',data)
}

//删除
export async function Delete(data) {
  return  api.delete('api/services/app/FrontendOrders/DeleteOrder?id='+ data.id)
}

//提交订单
export async function submitOrder(data) {
  return  api.post('api/services/app/FrontendOrders/SubmitOrder', data)
}

//获取订单
export async function getPaymentQrCode(data) {
  var paramStr='OrderCodes='+data.orderCodes;
  paramStr += '&OutTradeNo='+data.outTradeNo;
  paramStr += '&Method='+data.method;
  return  api.get('api/services/app/FrontendOrders/GetPaymentQrCode?'+ paramStr);
}

//获取订单支付状态
export async function getPayStatus(data) {
  return api.get('api/services/app/FrontendOrders/GetPayStatus?outTradeNo='+ data.outTradeNo)
}

//计算运费
export async function calculatePostFee(data) {
  return  api.post('api/services/app/FrontendOrders/CalculatePostFee', data)
}

//取消订单
export async function cancelOrder(data) {
  return  api.post('api/services/app/FrontendOrders/CancelOrder', data)
}

//修改地址
export async function changeAddress(data) {
  return  api.post('api/services/app/FrontendOrders/ChangeAddress', data)
}


//获取帮扶对象
export async function getVeterans(param) {

  var paramStr='1=1';
  if(param.Name!=null&&param.Name!=''&&param.Name!=undefined)
  {
    paramStr += '&Name='+encodeURIComponent(param.Name);
  }
  if(param.Province!=null&&param.Province!=''&&param.Province!=undefined)
  {
    paramStr += '&Province='+ encodeURIComponent(param.Province);
  }
  if(param.City!=null&&param.City!=''&&param.City!=undefined)
  {
    paramStr += '&City='+ encodeURIComponent(param.City);
  }
  if(param.Area!=null&&param.Area!=''&&param.Area!=undefined)
  {
    paramStr += '&District='+ encodeURIComponent(param.Area);
  }
  return  api.get('api/services/app/JunYuan/GetVeterans?'+ paramStr);
}

//获取帮扶对象
export async function getVeteran(param) {
  var paramStr='Id='+ param.id;
  return  api.get('api/services/app/JunYuan/GetVeteran?'+ paramStr);
}

//获取退款原因
export async function getRefundReasons(data) {
  return api.get('api/services/app/FrontendRefundReason/GetRefundReasons?refundType='+data.refundType)
}

export async function getCounsellings(params) {
  var paramStr='SkipCount='+ params.SkipCount;
  paramStr += '&MaxResultCount='+ params.MaxResultCount;
  paramStr += "&IsSaasUser=false";
  paramStr += "&UserId="+ params.UserId;
  return api.get('api/services/app/FrontendSupplier/GetCounsellings?'+paramStr)

}

//添加或编辑
export async function counsellingAsk(data) {
  return  api.post('api/services/app/FrontendSupplier/CounsellingAsk', data)

}



// WEBPACK FOOTER //
// ./src/api/order.js